import React from "react";

import { CityInfo } from "api/requests/getCityStateGeocode";
import { Category } from "constants/events";
import { useEventTracker } from "hooks/useEventTracker";

import MapCallout from "components/MapCallout";
import TrackImpression from "components/TrackImpression";

import AddressCaptureModal from "../AddressCaptureModal";

type Props = {
  deliveryCount: number;
  cityInfo?: CityInfo;
};

const PreaddressMap: React.FC<Props> = ({ deliveryCount, cityInfo }) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const sectionRef = React.useRef<HTMLElement>(null);
  const { publishEvent } = useEventTracker();

  let nearWhere = "you"; // "99 dispensaries near you"
  if (cityInfo?.state && cityInfo?.city) {
    // \u00A0: non breaking space
    nearWhere = `${cityInfo.city},\u00A0${cityInfo.state}`; // "...near Tucson, AZ"
  } else if (cityInfo?.stateLong) {
    nearWhere = cityInfo.stateLong; // "...near Arizona"
  }

  // @ts-ignore (fix me please, do not replicate)
  const handleClick = (ev) => {
    ev.preventDefault();
    setModalVisible(true);
    publishEvent({
      action: "click",
      category: "Delivery Gate Flow",
      label: "map block",
    });
  };

  return (
    <TrackImpression category={Category.deliveryGateFlow} label="map block">
      <AddressCaptureModal
        isVisible={modalVisible}
        onDismissed={() => setModalVisible(false)}
        returnFocusRef={sectionRef}
      />
      <section ref={sectionRef}>
        <MapCallout fadeBottom>
          <div className="flex flex-row">
            <span className="dispensariesCount">{deliveryCount}</span>
            <span className="ml-lg flex items-center">
              <button onClick={handleClick}>
                {" "}
                {`delivery dispensar${
                  deliveryCount > 1 ? "ies" : "y"
                } near ${nearWhere}`}
              </button>
            </span>
          </div>
        </MapCallout>
        <style jsx>
          {`
            .dispensariesCount {
              font-size: 40px;
              font-weight: 800;
              line-height: 48px;
            }
          `}
        </style>
      </section>
    </TrackImpression>
  );
};

export default PreaddressMap;
